import { registerUser, RegisterUserParams } from "../api/auth-request";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { HttpStatusCode, isAxiosError } from "axios";

const register = async (user: RegisterUserParams) => {
  const response = await registerUser(user);
  return response.data;
};

export const useCreateUser = () => {
  return useMutation({
    mutationFn: register,
    onSuccess: () => {
      toast.success("Registered Successfully!");
    },
    onError: (error) => {
      if (isAxiosError(error)) {
        switch (error.status) {
          case HttpStatusCode.BadRequest:
            toast.error("All fields were required");
            break;
          case HttpStatusCode.NotAcceptable:
            toast.error(error.message);
            break;
          default:
            toast.error("Something went wrong");
        }
      }
    },
  });
};
